var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{class:{ circle: _vm.circle }},[(_vm.image)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.url),expression:"url"}],key:_vm.image.url,ref:"image",attrs:{"data-zoom-src":_vm.image.url}}):_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.fallback),expression:"fallback"}],key:_vm.fallback})])
}
var staticRenderFns = []

export { render, staticRenderFns }